import PropTypes from 'prop-types'
import { MdTrendingUp, MdTrendingDown, MdRemove } from 'react-icons/md'

function AnalyticsCard({
  title,
  value,
  change,
  changeType = 'neutral',
  icon,
  iconBgColor = 'bg-primary-100 dark:bg-primary-900',
  iconColor = 'text-primary-600 dark:text-primary-400',
  subtitle,
  className = '',
}) {
  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return <MdTrendingUp className="text-success-500" />
      case 'negative':
        return <MdTrendingDown className="text-red-500" />
      default:
        return <MdRemove className="text-neutral-500" />
    }
  }

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success-600 dark:text-success-400'
      case 'negative':
        return 'text-red-600 dark:text-red-400'
      default:
        return 'text-neutral-600 dark:text-neutral-400'
    }
  }

  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000000) {
        return `${(val / 1000000).toFixed(1)}M`
      } else if (val >= 1000) {
        return `${(val / 1000).toFixed(1)}K`
      }
      return val.toLocaleString()
    }
    return val
  }

  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md p-6 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3">
            <div className={`w-12 h-12 ${iconBgColor} rounded-lg flex items-center justify-center`}>
              <div className={`${iconColor} text-xl`}>{icon}</div>
            </div>
            <div>
              <p className="text-sm font-medium text-neutral-600 dark:text-neutral-400">{title}</p>
              <p className="text-2xl font-bold text-neutral-900 dark:text-white mt-1">
                {formatValue(value)}
              </p>
              {subtitle && (
                <p className="text-xs text-neutral-500 dark:text-neutral-500 mt-1">{subtitle}</p>
              )}
            </div>
          </div>
        </div>

        {change !== undefined && (
          <div className="flex items-center space-x-1">
            {getChangeIcon(changeType)}
            <span className={`text-sm font-medium ${getChangeColor(changeType)}`}>
              {change > 0 ? '+' : ''}
              {change}%
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

AnalyticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  change: PropTypes.number,
  changeType: PropTypes.oneOf(['positive', 'negative', 'neutral']),
  icon: PropTypes.node.isRequired,
  iconBgColor: PropTypes.string,
  iconColor: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
}

export default AnalyticsCard
